import React, { useState, useEffect, useContext, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { disableHTMLOverflow } from 'Functions';
import Globals from '../Globals';
import { withCookies } from 'react-cookie';
import { UserContext } from 'contexts/UserContext';

function AppBlocked({ show, cookies }) {
    const { user } = useContext(UserContext);
    const [ariaHidden, setAriaHidden] = useState(!show);

    const isBanned = useCallback(
        user => {
            if (cookies.get(Globals.COOKIES.USER)) {
                var userT = cookies.get(Globals.COOKIES.USER);
                if (
                    user &&
                    user.data &&
                    user.logged &&
                    userT.toUpperCase() !== user.data.UserId &&
                    userT.toUpperCase() !== user.data.EmailLogin
                ) {
                    setAriaHidden(false);
                }
            }
        },
        [cookies]
    );

    useEffect(() => {
        let intervalId = setInterval(() => {
            isBanned(user);
        }, 10000);

        return () => clearInterval(intervalId);
    }, [isBanned, user]);

    const closeThisModal = () => {
        disableHTMLOverflow(false);
        setAriaHidden(true);
        window.location.reload();
    };

    return (
        <div
            className="c-modal c-modal--same-bid"
            aria-hidden={ariaHidden}
            id="modal-same-bid"
        >
            <div
                className="c-modal__overlay  js-modal-close"
                tabIndex="-1"
            ></div>
            <div
                className="c-modal__wrapper"
                role="dialog"
                aria-labelledby="modal-same-bid-title"
            >
                <header className="c-modal__header">
                    <div className="c-modal__title__wrapper">
                        <h1
                            className="c-modal__title"
                            id="modal-same-bid-title"
                        >
                            Vaya...
                        </h1>
                    </div>
                </header>
                <div className="c-modal__content" role="document">
                    <p className="u-mt-large">
                        Parece que alguien se ha conectado en el mismo navegador
                        que tú. Los datos de esta página se actualizarán con el
                        nuevo usuario!
                    </p>
                </div>
                <div className="c-modal__footer">
                    <div className="c-modal__actions">
                        <div className="c-modal__actions__item">
                            <button
                                className={'c-btn js-modal-close'}
                                aria-label="Baneado"
                                onClick={closeThisModal}
                            >
                                <span className="c-btn__text">Refrescar</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withCookies(withRouter(AppBlocked));
